import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import CompareViewModel from "../viewModel";
import { getMultiLangProperty } from "../../../helpers/generalHelper";

const ModelAndOption = () => {
  const { t, i18n } = useTranslation();
  const { compareItems } = useContext(CompareViewModel.Context);

  return (
    <tr>
      <th className="title-column">
        {`${t("compare.sku")} & ${t("compare.option")}`}
      </th>
      {compareItems.map((compareItem) => (
        <td
          key={compareItem._id}
          style={{ width: `${100 / compareItems.length}%` }}
        >
          <ul>
            {Array.isArray(compareItem.variations) &&
            compareItem.variations.length >= 1
              ? compareItem.variations.map(({ label, options }, index) => (
                <ul key={index}>
                    <b>{getMultiLangProperty(label, i18n.language)}</b>
                    {options.map((option, optionIndex) => (
                    <li key={optionIndex}>
                        {`- ${getMultiLangProperty(
                          option.label,
                          i18n.language
                        )}`}
                      </li>
                    ))}
                  </ul>
                ))
              : "---"}
          </ul>
        </td>
      ))}
    </tr>
  );
};

export default ModelAndOption;
